<template lang="">
  <div class="login login-3 login-signin-on d-flex flex-row-fluid" id="kt_login">
    <div class="d-flex flex-center bgi-size-cover bgi-no-repeat flex-row-fluid" style="background-image: url(static/img/default/login-v2.jpg);">
      <div class="login-form text-center text-white p-7 position-relative overflow-hidden rounded" style="backdrop-filter: blur(9px);background-color: rgba(255,255,255,0.20)">
        <!--begin::Login Header-->
        <div class="d-flex flex-center mb-15">
          <router-link :to="{ path: '/login' }">
            <img :src="$_config.logo.lg" class="max-h-100px" alt="" />
            <img :src="'/static/img/logo/infra-2.svg'" alt="Logo" class="max-h-70px" />
          </router-link>
        </div>
        <!--end::Login Header-->

        <!--begin::Login Sign in form-->
        <div v-if="state === 'signin'" :class="[state === 'signin' ? 'd-block' : 'd-none']" class="login-signin">
          <div class="mb-20">
            <h1>{{ $_config.name }}</h1>
            <h3>{{ $_config.desc }}</h3>
            <p class="opacity-60 font-weight-bold">{{ $_config.fullname }}</p>
          </div>
          <form @submit="loginState($event)" class="form fv-plugins-bootstrap fv-plugins-framework position-relative" id="kt_login_signin_form" novalidate="novalidate">
            <b-overlay :show="isLoading" variant="white" nowrap />
            <div class="form-group fv-plugins-icon-container">
              <div class="text-left px-8">
                <label class="text-white font-weight-bold">Email / Username</label>
              </div>
              <input v-model.lazy.trim="username" class="form-control fc-custom h-auto text-white placeholder-white opacity-70 bg-dark-o-70 rounded-pill border-0 py-4 px-8 mb-5" type="text" placeholder="Email" name="username" autocomplete="off" />
              <div class="fv-plugins-message-container"></div>
            </div>
            <div class="form-group fv-plugins-icon-container has-success">
              <div class="d-flex justify-content-between mt-5 px-8">
                <label class="text-white font-weight-bold">Password</label>
                <a v-if="$_config.options.forgetPassword" @click="state = 'forgot'" class="text-white font-weight-bold text-hover-primary pointer" id="kt_login_forgot">Lupa Password ?</a>
              </div>
              <div class="input-icon input-icon-right">
                <input v-model.lazy.trim="password" :type="showPassword ? 'text' : 'password'" class="form-control fc-custom h-auto text-white placeholder-white opacity-70 bg-dark-o-70 rounded-pill border-0 py-4 px-8" placeholder="Kata Sandi" />
                <span class="pointer" @click="showPassword = !showPassword">
                  <i v-if="!showPassword" class="ri-lock-password-line ri-2x pr-4"></i>
                  <i v-else class="ri-lock-unlock-line ri-2x pr-4"></i>
                </span>
              </div>
              <div class="fv-plugins-message-container"></div>
            </div>
            <div v-if="errorLogin" class="alert alert-custom alert-light-danger p-2 my-2" role="alert">
              <div class="alert-icon">
                <i class="ri-error-warning-fill text-danger"></i>
              </div>
              <div class="alert-text text-danger text-left">
                {{ errorLogin }}
                <p class="mt-3 mb-0" v-if="showResendEmail">
                  Belum mendapat email Verifikasi?
                  <br />
                  <a class="text-primary pointer" @click="resendVerification()">
                    Kirim ulang
                    <span v-if="resendWaiting > 0">({{ resendWaiting }})</span>
                  </a>
                </p>
              </div>
            </div>
            <div class="form-group text-center mt-10">
              <button id="kt_login_signin_submit" class="btn btn-pill btn-outline-white font-weight-bold opacity-90 px-15 py-3">Login</button>
            </div>
          </form>
          <div v-if="$_config.options.allowRegister" class="mt-10">
            <span class="opacity-70 mr-4">
              Belum memiliki akun ?
            </span>
            <router-link :to="{ path: '/register' }" id="kt_login_signup" class="text-white font-weight-bold">Daftar Sekarang</router-link>
          </div>
          <div class="text-center mt-8">
            <a v-if="$_config.guide" :href="$_config.guide" target="_blank" class="text-center text-muted text-hover-white">
              <span class="d-flex align-items-center justify-content-center font-weight-bold mb-2">
                <i class="ri-book-mark-line mr-1"></i>
                Panduan Penggunaan
              </span>
              <span class="d-block font-weight-bolder font-size-h5">{{ $_config.name }} - {{ $_config.fullname }}</span>
            </a>
            <span v-else class="font-weight-bolder font-size-h5 text-muted">{{ $_config.fullname }}</span>
          </div>
        </div>
        <!--end::Login Sign in form-->

        <!--begin::Login Sign up form-->
        <div class="login-signup">
          <div class="mb-20">
            <h3>Sign Up</h3>
            <p class="opacity-60">Enter your details to create your account</p>
          </div>
          <form class="form text-center fv-plugins-bootstrap fv-plugins-framework" id="kt_login_signup_form">
            <div class="form-group fv-plugins-icon-container">
              <input class="form-control h-auto text-white placeholder-white opacity-70 bg-dark-o-70 rounded-pill border-0 py-4 px-8" type="text" placeholder="Fullname" name="fullname" />
              <div class="fv-plugins-message-container"></div>
            </div>
            <div class="form-group fv-plugins-icon-container">
              <input class="form-control h-auto text-white placeholder-white opacity-70 bg-dark-o-70 rounded-pill border-0 py-4 px-8" type="text" placeholder="Email" name="email" autocomplete="off" />
              <div class="fv-plugins-message-container"></div>
            </div>
            <div class="form-group fv-plugins-icon-container">
              <input class="form-control h-auto text-white placeholder-white opacity-70 bg-dark-o-70 rounded-pill border-0 py-4 px-8" type="password" placeholder="Password" name="password" />
              <div class="fv-plugins-message-container"></div>
            </div>
            <div class="form-group fv-plugins-icon-container">
              <input class="form-control h-auto text-white placeholder-white opacity-70 bg-dark-o-70 rounded-pill border-0 py-4 px-8" type="password" placeholder="Confirm Password" name="cpassword" />
              <div class="fv-plugins-message-container"></div>
            </div>
            <div class="form-group text-left px-8 fv-plugins-icon-container">
              <div class="checkbox-inline">
                <label class="checkbox checkbox-outline checkbox-white text-white m-0">
                  <input type="checkbox" name="agree" />
                  <span></span>
                  I Agree the
                  <a href="#" class="text-white font-weight-bold ml-1">terms and conditions</a>
                  .
                </label>
              </div>
              <div class="form-text text-muted text-center"></div>
              <div class="fv-plugins-message-container"></div>
            </div>
            <div class="form-group">
              <button id="kt_login_signup_submit" class="btn btn-pill btn-outline-white font-weight-bold opacity-90 px-15 py-3 m-2">Sign Up</button>
              <button id="kt_login_signup_cancel" class="btn btn-pill btn-outline-white font-weight-bold opacity-70 px-15 py-3 m-2">Cancel</button>
            </div>
            <div></div>
          </form>
        </div>
        <!--end::Login Sign up form-->

        <!--begin::Login forgot password form-->
        <div v-if="state === 'forgot'" :class="[state === 'forgot' ? 'd-block' : 'd-none']" class="login-forgot">
          <div class="mb-20">
            <h3>Lupa Password ?</h3>
            <p class="opacity-60">
              Kami Akan mengirimkan link URL
              <br />
              untuk mengganti password ke Email Anda
            </p>
          </div>
          <div v-if="errorLogin" class="alert alert-custom alert-default p-2" role="alert">
            <div class="alert-icon">
              <i class="ri-error-warning-fill text-danger"></i>
            </div>
            <div class="alert-text text-danger text-left">{{ errorLogin }}</div>
          </div>
          <form @submit.prevent="forgetPassword()" class="form fv-plugins-bootstrap fv-plugins-framework" id="kt_login_forgot_form">
            <div class="form-group mb-10 fv-plugins-icon-container">
              <input v-model="forgetEmail" class="form-control fc-custom h-auto text-white placeholder-white opacity-70 bg-dark-o-70 rounded-pill border-0 py-4 px-8" type="text" placeholder="Email" name="email" autocomplete="off" />
              <div class="fv-plugins-message-container"></div>
            </div>
            <div class="form-group">
              <button :disabled="!forgetEmail" id="kt_login_forgot_submit" type="submit" class="btn btn-pill btn-outline-white font-weight-bold opacity-90 px-15 py-3 m-2">Kirim Email</button>
              <button @click="state = 'signin'" id="kt_login_forgot_cancel" type="button" class="btn btn-pill btn-outline-white font-weight-bold opacity-70 px-15 py-3 m-2">Cancel</button>
            </div>
            <div></div>
          </form>
        </div>
        <!--end::Login forgot password form-->
        <div v-if="state === 'forgot-success'" :class="[state === 'forgot-success' ? 'd-block' : 'd-none']" class="login-forgot">
          <div class="text-center pb-8">
            <h2 class="font-weight-bolder text-dark font-size-h2 font-size-h1-lg">Email Terkirim</h2>
            <div class="text-muted font-weight-bold font-size-h4">
              Silahkan periksa Email Anda, atau
              <br />
              <a @click="state = 'signin'" class="text-primary font-weight-bold pointer text-hover-primary">Ke Halaman Login</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'login-page',
  data () {
    return {
      state: 'signin',
      username: null,
      password: null,
      showPassword: false,
      errorLogin: null,
      forgetEmail: null,
      showResendEmail: false,
      tmp_user: null,
      resendWaiting: 0,
      isLoading: false
    }
  },
  mounted () {
    this.$store.commit('set', ['appcode', this.$_config.code, true])
  },
  methods: {
    loginState (e) {
      e.preventDefault()
      if (this.username && this.password) {
        let data = { username: this.username, password: this.password }
        if (this.$_config.options.sso) data.app_code = this.$_config.code
        this.isLoading = true
        this.$_api[this.$_config.options.sso ? 'sso' : 'post']('/login', data)
          .then((res) => {
            this.isLoading = false
            if (res.token) this.saveProfile(res)
            else this.actionUser(res.data_user_before_login, res.message)
          })
          .catch((err) => {
            this.isLoading = false
            this.errorLogin = err.data.message
          })
        this.errorLogin = null
      } else {
        this.errorLogin = 'Username & Password harus diisi'
      }
    },
    actionUser (data, message) {
      this.tmp_user = data
      if (data.status_code === 'email_unverified') {
        this.showResendEmail = true
        this.errorLogin = message
      } else if (data.status_code === 'email_verified') {
        this.$router.push({ name: 'waiting-apps', params: { user: data } })
      } else this.errorLogin = message
    },
    resendVerification () {
      if (this.resendWaiting === 0) {
        this.$_api
          .post('/request_email_verification', this.tmp_user)
          .then((res) => {
            this.resendWaiting = 60
            this.setWaiting()
          })
          .catch((err) => {
            this.errorLogin = err.data.message
          })
      }
    },
    setWaiting () {
      setTimeout(() => {
        if (this.resendWaiting > 0) {
          this.resendWaiting--
          this.$nextTick()
          this.setWaiting()
        }
      }, 1000)
    },
    async saveProfile (e) {
      if (this.$_config.options.autofill) {
        let deptList = e.departments.map((x) => {
          return { label: x.department_name, code: x.id }
        })
        let projList = e.projects.map((x) => {
          return { label: x.project_name, code: x.id }
        })
        let autofill = {
          department_id: {
            value: deptList.length > 0 ? deptList[0].code : null,
            list: deptList
          },
          project_id: {
            value: projList.length > 0 ? projList[0].code : null,
            list: projList
          }
        }
        this.$store.commit('set', ['autofill', autofill, true])
      }
      this.$store.commit('set', ['profile', e.user, true])
      this.$store.commit('set', ['_token', e.token, true])
      this.$store.commit('set', ['permission', e.permissions, true])
      await this.$store.dispatch('setModule')
      this.$router.push({ name: 'main-module' })
    },
    forgetPassword () {
      this.$_api
        .post('/request-change-password', { email: this.forgetEmail })
        .then((res) => {
          this.forgetEmail = null
          this.state = 'forgot-success'
        })
        .catch((err) => {
          this.errorLogin = err.data.message
        })
    }
  }
}
</script>
<style>
  .login.login-3 .login-signin,
  .login.login-3 .login-signup,
  .login.login-3 .login-forgot {
    display: none;
  }
  .login.login-3.login-signin-on .login-signup {
    display: none;
  }
  .login.login-3.login-signin-on .login-signin {
    display: block;
  }
  .login.login-3.login-signin-on .login-forgot {
    display: none;
  }
  .login.login-3.login-signup-on .login-signup {
    display: block;
  }
  .login.login-3.login-signup-on .login-signin {
    display: none;
  }
  .login.login-3.login-signup-on .login-forgot {
    display: none;
  }
  .login.login-3.login-forgot-on .login-signup {
    display: none;
  }
  .login.login-3.login-forgot-on .login-signin {
    display: none;
  }
  .login.login-3.login-forgot-on .login-forgot {
    display: block;
  }

  .login.login-3 .login-form {
    width: 100%;
    max-width: 500px;
  }

  @media (max-width: 575.98px) {
    .login.login-3 .login-form {
      width: 100%;
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/default-page/login-2.vue